<template>
  <Courses :courses="courses" :router-link="routerLink" />
</template>

<script>
// import Course from "@/components/teacher/Course"
import Courses from '@/components/atomic/templates/Courses.vue';
import { mapActions } from 'vuex';

export default {
  name: 'CoursesList',

  components: {
    // Course
    Courses,
  },

  data() {
    return {
      courses: [],
      routerLink: '/teacher/courses/new',
    };
  },

  async created() {
    this.courses = await this.getMyCourses();
    console.log('normal', this.courses);
    this.courses.reverse();
    console.log('invertido', this.courses);
  },

  methods: {
    ...mapActions('teacher', ['getMyCourses']),
  },
};
</script>

<style lang="scss" scoped></style>
